var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircledFaceDefault = function SvgCircledFaceDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 71 71"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 35.5,
    fill: "#3026A4",
    transform: "matrix(0 1 1 0 35.5 35.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M36 28.666v7.125a2.375 2.375 0 0 1-2.375 2.375h-.791m-4.75-9.5v3.958m15.833-3.958v3.958M29.244 42.916a8.677 8.677 0 0 0 11.929 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.792 35a18.21 18.21 0 0 0 31.084 12.875 18.208 18.208 0 1 0-31.084-12.876z"
  })));
};
export default SvgCircledFaceDefault;